var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43066 0.647461C4.28854 0.647461 0.930664 4.00533 0.930664 8.14746V41.1475C0.930664 45.2896 4.28854 48.6475 8.43066 48.6475H41.4307C45.5728 48.6475 48.9307 45.2896 48.9307 41.1475V8.14746C48.9307 4.00533 45.5728 0.647461 41.4307 0.647461H8.43066ZM29.608 12.6475C29.608 13.0041 29.6413 13.3553 29.7027 13.6952C29.9978 15.2666 30.9277 16.615 32.2195 17.4563C33.1214 18.047 34.1904 18.387 35.3429 18.387L35.3427 19.3064V22.5104C33.2047 22.5104 31.2226 21.8251 29.6079 20.666V29.0523C29.6079 33.2372 26.2006 36.6475 22.0193 36.6475C20.4047 36.6475 18.9014 36.1347 17.6709 35.271C15.7112 33.8946 14.4307 31.6211 14.4307 29.0523C14.4307 24.862 17.8325 21.4573 22.0137 21.4628C22.3645 21.4628 22.7041 21.4907 23.0382 21.5353V22.5104L23.026 22.5163L23.0382 22.516V25.748C22.7153 25.6476 22.3701 25.5864 22.0137 25.5864C20.104 25.5864 18.5507 27.1411 18.5507 29.0523C18.5507 30.3842 19.3079 31.5376 20.4102 32.1227C20.4266 32.1451 20.4432 32.1672 20.46 32.1891C20.4473 32.1647 20.4326 32.1406 20.4159 32.1171C20.9002 32.3735 21.4458 32.5183 22.0249 32.5183C23.89 32.5183 25.4156 31.0306 25.4824 29.1806L25.4879 12.6475H29.608Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.0b1714aab023745a0c2c9161f7a3a4ff.svg";
export { ForwardRef as ReactComponent };